<template>
    <a v-if="author.profile_updated && author.phone_verified" :href="root.url('orn_web_user_view', { username: author.username })" class="text-danger">
        {{ author.display_name }}
    </a>
    <span v-else>{{ author.display_name }}</span>
</template>

<script setup>
import { inject } from 'vue'

const props = defineProps({
    author: {
        type: Object,
        required: true
    }
})

const root = inject('root')
</script>

<style scoped>
</style>